import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // skip static assets
  if (req.url.startsWith('assets/')) return next(req);
  const auth = inject(AuthService);
  const token = auth.token;
  // Always overwrite Authorization with the latest token to avoid stale headers from prior requests
  if (token) {
    req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
  return next(req);
};
